module.exports = __webpack_public_path__ + "img/zxcMap.c4724441.png";